export async function fetchPdfUrl(api, quoteId, plain = false) {
  const r = await api.get(`/quotes/${quoteId}/pdf`, { responseType: "blob", params: plain ? { plain: true } : {} });
  return URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
}

export async function openPdf(api, q, download, plain = false) {
  const url = await fetchPdfUrl(api, q.id, plain);
  if (!download) return url;
  const a = document.createElement("a");
  a.href = url;
  a.download = `Preventivo_${(q.code || "").replace(/[/ ]/g, "_")}${plain ? "_senza_prezzi" : ""}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
  return null;
}
